import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f15ba1aa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f15ba1aa')) {
      api.createRecord('f15ba1aa', component.options)
    } else {
      api.reload('f15ba1aa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f15ba1aa&", function () {
      api.rerender('f15ba1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EZgqSibwY8JJ/JS/comp/ImgFallback.vue"
export default component.exports